import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { myFeatureRequests, requestFeature } from "../../api/features";
import { NeuButton } from "../neu/Neu";

// يسمح لمدير الشركة بطلب تفعيل ميزة مغلقة؛ الطلب يصل لمالك المنصة.
export const RequestFeatureButton = ({ feature, initialAsked }) => {
  const { t } = useTranslation();
  const [asked, setAsked] = useState(initialAsked ?? null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (initialAsked !== undefined) return;
    myFeatureRequests()
      .then((data) => setAsked(data.requested.includes(feature)))
      .catch(() => setAsked(false));
  }, [feature, initialAsked]);

  if (asked === null) return null;

  const ask = async () => {
    setBusy(true);
    try {
      await requestFeature(feature);
      setAsked(true);
      toast.success(t("features.requestSent"));
    } finally {
      setBusy(false);
    }
  };

  if (asked) {
    return (
      <p className="text-xs font-bold text-primary" data-testid={`feature-requested-${feature}`}>
        {t("features.requestPending")}
      </p>
    );
  }

  return (
    <NeuButton
      variant="primary"
      className="px-5 py-2 text-xs"
      data-testid={`feature-request-btn-${feature}`}
      disabled={busy}
      onClick={ask}
    >
      {t("features.requestActivation")}
    </NeuButton>
  );
};
